<top-bar [newUrl]="newUrl"></top-bar>
<router-outlet></router-outlet>